var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-details"},[_c('Form',{ref:"form",attrs:{"form-data":_vm.formData,"default-values":_vm.fieldValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }